import styled from '@emotion/styled';
import { TableCell, tableCellClasses } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor:
      // theme.palette.common.black
      "#a7c4dc"
    ,
    // color: theme.palette.common.white,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: theme.palette.common.gray,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: theme.palette.common.gray,
  },
}));

export default StyledTableCell;